import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const Reports: React.FC = () => {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Reportes
      </Typography>
      <Paper sx={{ p: 3, mt: 2 }}>
        <Typography variant="body1" color="text.secondary">
          Análisis y métricas del sistema de gestión de proveedores.
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
          Reportes de gasto por proveedor, concentración por categoría, 
          distribución geográfica, tendencias temporales y análisis de evaluaciones.
        </Typography>
      </Paper>
    </Box>
  );
};

export default Reports;
